// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationButton_button__T8iqR","active":"NavigationButton_active__HMHgx","icon":"NavigationButton_icon__2Kmg9"};